import React from "react";
import {
  refreshNotifications,
  seenNotification,
} from "../../api/notifications";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

import "./Notifications.scss";
import { connect } from "react-redux";

import { XHRImage as Image } from "../Media/Image";

import blackLogo from "../../ressources/images/notifications/oneretail-black.png";
import whiteLogo from "../../ressources/images/notifications/oneretail-white.png";
import { motion } from "framer-motion";
import "moment/min/locales";
import {
  LazyLoadImage,
} from "react-lazy-load-image-component";

const NotifImage = ({ notification }) => {
  const { type, image } = notification;

  switch (type) {
    case "BA_BIRTHDAY_ACCOUNT":
    case "POST_DELETE":
    case "GROUP_DELETE":
    case "GROUP_ADD":
      return (
        <LazyLoadImage
          effect="blur"
          className="notification__img"
          width={50}
          height={50}
          src={blackLogo}
        ></LazyLoadImage>
      );
    // return <img className="notification__img" src={blackLogo} alt="" />;

    case "BA_BIRTHDAY":
    case "LEVELED_POINTS":
      return (
        <LazyLoadImage
          effect="blur"
          className="notification__img"
          width={50}
          height={50}
          src={whiteLogo}
        ></LazyLoadImage>
      );
    // return <img className="notification__img" src={whiteLogo} alt="" />;

    default:
      return (
        <LazyLoadImage
          effect="blur"
          className="notification__img"
          width={50}
          height={50}
          src={image}
        ></LazyLoadImage>
      );
    // return <img className="notification__img" src={image} alt="" />;
  }
};

const NotificationLink = ({ notification, onClick }) => {
  if (notification.type === "PRODUCT_CATALOG") {
    // const url = notification.url.slice(0, 0);
    return (
      <a
        className={`container__notification ${
          notification.seen ? "" : "container__notification--seen"
        }`}
        exact="true"
        href={`${process.env.REACT_APP_BACKEND}${notification.url.slice(
          1,
          notification.url.length
        )}`}
        onClick={onClick}
      >
        <NotifImage notification={notification} />
        <div className="container__notification--text">
          <p className="notification__text">{notification.title}</p>
          <p className="notification__text--time">
            {notification.datetime_label}
          </p>
        </div>
      </a>
    );
  }

  return (
    <Link
      className={`container__notification ${
        notification.seen ? "" : "container__notification--seen"
      }`}
      exact="true"
      to={{
        pathname: notification.url,
        state: { transitionName: "fade_app" },
      }}
      onClick={onClick}
    >
      {notification.type === "POST_LIKE" ||
      notification.type === "POST_COMMENT" ? (
        <Image className="notification__img" src={notification.image} alt="" />
      ) : (
        <NotifImage notification={notification} />
      )}
      <div className="container__notification--text">
        <p className="notification__text">{notification.title}</p>
        <p className="notification__text--time">
          {notification.datetime_label}
        </p>
      </div>
    </Link>
  );
};

const Notifications = (props) => {
  //   const history = useHistory();

  const setSeenNotification = (id) => {
    seenNotification(id)
      .then(() => {
        refreshNotifications();
        props.onClose();
      })
      .catch((err) => console.log(err));
  };

  const { notifications } = props.notifications;

  return (
    <motion.div
      transition={{
        duration: 0.2,
        delay: 0,
        ease: "easeIn",
      }}
      initial={{ y: "-100%" }}
      animate={{ y: "0%" }}
      exit={{ y: "-100%" }}
      className="main__container--notifications"
    >
      <div className="container__title--notifications">
        <h1>{props.t("notifications")}</h1>
        <button onClick={props.onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="ionicon"
            viewBox="0 0 512 512"
          >
            <title>Close</title>
            <path
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="32"
              d="M368 368L144 144M368 144L144 368"
            />
          </svg>
        </button>
      </div>

      {notifications ? (
        notifications.map((notification, i) => {
          return (
            <NotificationLink
              notification={notification}
              key={i}
              onClick={() => setSeenNotification(notification.id)}
            />
          );
        })
      ) : (
        <div></div>
      )}
    </motion.div>
  );
};

const mapStateToProps = (state) => ({
  notifications: state.notifications,
});

export default connect(mapStateToProps)(
  withTranslation()(Notifications)
);
